import NewTable, { TableBodyData, TableHeaderColumn } from "components/NewTable";
import PageDefault from "components/PageDefault";
import { Button, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { formatDocument } from "utils/format";
import { formatMoneyByCurrency } from "utils/currency";
import { useTranslation } from 'react-i18next';
// import { useUser } from 'store/models';
// import SelectYear from 'components/SelectYear';
import fundService from 'services/fund.service';

export default function Budget() {
  const { t } = useTranslation()
  // const user = useUser();
  // const datetime = user.getDatetime();
  // const [ year, setYear ] = useState(()=>{return datetime?datetime.year:"2021"});

  return (<>
    <PageDefault title={t("budget:page_title")}>
      <PageDefault.Title>{t("budget:page_title")}</PageDefault.Title>
      <PageDefault.Content>
        <Row className="mt-3 mb-3">
          <Col>
            <Link to="/budget/create">
              <Button>{t("budget:add_btn")}</Button>
            </Link>
          </Col>
          <Col xs="auto">
            {/* <Row>
              <SelectYear value={year} onChange={setYear}/>
            </Row> */}
          </Col>
        </Row>
        <NewTable>
          <TableHeaderColumn dataField="company.name">{t("budget:table_header:name")}</TableHeaderColumn>
          <TableHeaderColumn dataField="company.document" mask={formatDocument}>{t("budget:table_header:document")}</TableHeaderColumn>
          <TableHeaderColumn dataField="fund_type.name">{t("budget:table_header:fund_type")}</TableHeaderColumn>
          <TableHeaderColumn dataField="payment_method.name">{t("budget:table_header:payment_method")}</TableHeaderColumn>
          <TableHeaderColumn dataField="value" mask={(value:any)=>{
            return formatMoneyByCurrency(value??0, 1);
          }}>{t("budget:table_header:total_value")}</TableHeaderColumn>
          <TableHeaderColumn dataField="value_used" mask={(value:any)=>{
            return formatMoneyByCurrency(value??0, 1);
          }}>{t("budget:table_header:used_value")}</TableHeaderColumn>
          <TableBodyData 
            request={fundService} 
            filterDefaut={{
              embed:"company:name,alias,document,id|fund_type|payment_method"
            }}
          />
        </NewTable>
      </PageDefault.Content>
    </PageDefault>
  </>);
}

export { default as ActionForm } from "./BudgetForm";